import { useEffect } from 'react';
export const useMount = (mountFn, unMountFn) => useEffect(() => {
  mountFn();
  return unMountFn;
}, []); // eslint-disable-line

export default useMount;